import { Component, ElementRef, Input, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NgxSpinnerService } from 'ngx-bootstrap-spinner';
import { Subscription, timer } from "rxjs";
import { LayoutService } from "../../../shared/services/layout.service";
import { APIService } from "../../APIService";

@Component({
  selector: "app-right-panel",
  templateUrl: "./right-panel.component.html",
  styleUrls: ["./right-panel.component.scss"],
})
export class RightPanelComponent implements OnInit {
  @ViewChild('clock') clock: ElementRef;
  rightPanelStatus = false;
  lHeaderTheme: any;
  headerTheme: any;
  leftPanelTheme: any;
  navBarMenuEffectList = [];
  navbarEffect: any;
  public passwordForm: FormGroup;
  public validateCodeForm: FormGroup;
  public errorMessage = "";
  errorMessageValidToken = "";
  whiteSpaceRegex = /^[^\s]+(\s+[^\s]+)*$/;
  subscriptions: Subscription[] = [];
  countDown: Subscription;
  showVerificationForm = false;

  msgValidated = '';
  showValidationError = '';
  showPassErr = '';
  passwordHistoryDate ='';

  showTokenBar = false;
  passwordReqSentMsg = ''
  changeInCode = '';
  buttonDisabled = false;
  counter = 300;
  tick = 1000;
  // @Input() rsOpenStatus: boolean;
  constructor(
    private layoutService: LayoutService,
    private formbuilder: FormBuilder,
    private _apiService: APIService,
    private spinner: NgxSpinnerService
  ) {

    // this.subscriptions.push(
    //   this._apiService.GetPassHist().subscribe((hist) => {
    //     this.passwordHistoryDate = hist.result;
    //   })
    // );

    this.subscriptions.push(
      this._apiService.errorOfValToken.subscribe((errorMessage) => {
        this.errorMessageValidToken = errorMessage;
      })
    );

    this.subscriptions.push(
      this._apiService.disableButton.subscribe((bool) => {
        this.buttonDisabled = bool;
      })
    );

    this.passwordForm = this.formbuilder.group({
      password: [
        "",
        [
          Validators.required,
          Validators.minLength(6),
          Validators.pattern(this.whiteSpaceRegex)
        ],
      ],

      repassword: [
        "",
        [
          Validators.required,
          Validators.minLength(6),
          Validators.pattern(this.whiteSpaceRegex)
        ],
      ],
    });

    this.validateCodeForm = this.formbuilder.group({
      code: [
        "",
        [
          Validators.required,
          Validators.minLength(3)
        ],
      ],
    });
  }

  changeTheRightPanelStatus() {
    this.rightPanelStatus = !this.rightPanelStatus;
    this.layoutService.rsToggleStatus.next(this.rightPanelStatus)
  }

  setThemeLayout(event: any) {
    if (event.target.checked) {
      this.layoutService.getThemeLayout("box");
    } else {
      this.layoutService.getThemeLayout("wide");
    }
  }
  setCollapsedLeftHeader(event: any) {
    if (event.target.checked) {
      this.layoutService.getCollapsedLeftHeader(true);
    } else {
      this.layoutService.getCollapsedLeftHeader(false);
    }
  }

  changeType(id) {
    (document.getElementById('password') as any).type = "password"
  }

  changeTypeRe(){
    (document.getElementById('repassword') as any).type = "password"

  }
  changeNavbar(event: any) {
    if (event.target.checked) {
      this.layoutService.getNavLayout("horizontal");
    } else {
      this.layoutService.getNavLayout("vertical");
    }
  }

  onLheaderThemeChange(themeName: string) {
    event.stopPropagation();
    this.layoutService.getLeftHeaderThemeOnChange(themeName);
  }
  onHeaderThemeChange(themeName: string) {
    this.layoutService.getHeaderThemeOnChange(themeName);
  }
  onAsidebarThemeChange(themeName: string) {
    // event.stopPropagation();
    this.layoutService.getAsidebarThemeOnChange(themeName);
  }
  onChangeEffect(effect: string) {
    this.layoutService.getNavBarEffect(effect);
    if (effect === "overlay" || effect === "push") {
      this.layoutService.getDefaultNavbar("offcanvas");
      this.layoutService.getToggleNavbar("expanded");
    }
  }
  ngOnInit() {

    this.layoutService.rsToggleStatusCast.subscribe((i) => {
      this.rightPanelStatus = i;
    });

    this.navBarMenuEffectList = this.layoutService.navBarMenuEffect;
    this.layoutService.nvEffectCast.subscribe(
      (nvEffect) => (this.navbarEffect = nvEffect)
    );

    this.lHeaderTheme = [
      {
        theme: "theme1",
      },
      {
        theme: "theme2",
      },
      {
        theme: "theme3",
      },
      {
        theme: "theme4",
      },
      {
        theme: "theme5",
      },
      {
        theme: "theme6",
      },
      {
        theme: "theme7",
      },
    ];
    this.headerTheme = [
      {
        theme: "theme1",
      },
      {
        theme: "theme2",
      },
      {
        theme: "theme3",
      },
      {
        theme: "theme4",
      },
      {
        theme: "theme5",
      },
      {
        theme: "theme6",
      },
      {
        theme: "theme7",
      },
    ];
    this.leftPanelTheme = [
      {
        theme: "theme1",
      },
      {
        theme: "theme2",
      },
      {
        theme: "theme3",
      },
      {
        theme: "theme4",
      },
      {
        theme: "theme5",
      },
      {
        theme: "theme6",
      },
      {
        theme: "theme7",
      },
    ];

    this.onValueChanges();
  }

  ngAfterViewInit() {
    this.subscriptions.push(
      this._apiService.errorMessage.subscribe((message) => {
        if (message && message.length) {
          this.errorMessage = message;
        }
      })
    );
  }
  onValueChanges() {
    this.passwordForm.valueChanges.subscribe((res) => {
      if (res.password && res.password.length <= 5) {
        this.showPassErr = "Password should have a minimum length of 6 characters.";
 
      }
      else {
        this.showPassErr = "";
      }

      if (res.repassword && res.repassword.length <= 5) {
        if (this._apiService.errorMessage.getValue().indexOf("Confirm password should have a minimum length of 6 characters.") === -1) {
          this._apiService.errorMessage.getValue().push("Confirm password should have a minimum length of 6 characters."); this._apiService.errorMessage.next(this._apiService.errorMessage.getValue());
        } else return;
      }
      else {
        this._apiService.errorMessage.getValue().splice(this._apiService.errorMessage.getValue().indexOf("Confirm password should have a minimum length of 6 characters."), 1);
        this._apiService.errorMessage.next(this._apiService.errorMessage.getValue());
      }

      if (res.repassword && res.repassword !== res.password) {
        this._apiService.disableButton.next(true);
        if (this._apiService.errorMessage.getValue().indexOf("Both passwords do not match!") === -1) {
          this._apiService.errorMessage.getValue().push("Both passwords do not match!"); this._apiService.errorMessage.next(this._apiService.errorMessage.getValue());
        } else return;
      }
      else {
        this._apiService.disableButton.next(false);

        this._apiService.errorMessage.getValue().splice(this._apiService.errorMessage.getValue().indexOf("Both passwords do not match!"), 1);
        this._apiService.errorMessage.next(this._apiService.errorMessage.getValue());
      }

    });
  }

  // ChangePassword() {
  //   this.spinner.show('passwordSpinner');
  //   if(this.countDown) this.countDown.unsubscribe();
  //   if (this.passwordForm.valid) {
  //     this._apiService
  //       .sendPassword(this.passwordForm.value.password)
  //       .subscribe((res) => {
  //         if (res.status == "ok") {
  //           this.passwordForm.reset();
  //           this.passwordReqSentMsg = "Change Password Request Sent Successfully!"
  //           setTimeout(() => {
  //             this.passwordReqSentMsg = "";
  //             this.showTokenBar = true;
  //               this.countDown = timer(0, this.tick).subscribe((res) => {
  //                 --this.counter;
  //                 // if(this.validateCodeForm.value.code){
  //                 //   this.countDown.unsubscribe();
  //                 //   this.showTokenBar = false;
  //                 //   setTimeout(() => {
                      
  //                 //     this.layoutService.rsToggleStatus.next(false);
  //                 //   }, 2000);
  //                 // }
  //                 if (res == 299) {//&& !this.validateCodeForm.value.code) || (res == 9 && this.validateCodeForm.value.code && this.errorMessageValidToken)) {
  //                   this.countDown.unsubscribe();
  //                   this.showValidationError = 'Token expired, Please try again!';
  //                   // this._apiService.disableButton.next(true);
  //                   setTimeout(() => {
  //                     this.showTokenBar = false;
  //                     this.counter = 300;
  //                     this.countDown.unsubscribe();
  //                     this.showValidationError = '';
  //                     this._apiService.errorOfValToken.next("");
  //                     this._apiService.disableButton.next(false);
  //                     this.validateCodeForm.value.code = "";
  //                     this.validateCodeForm.reset();
  //                   }, 2000);
  //                 }
  //               });
  //           }, 500);
  //           this.spinner.hide('passwordSpinner');
  //         } else {
  //           if (this._apiService.errorMessage.getValue().indexOf("Something went wrong, Please try again later!") === -1) {
  //             this._apiService.errorMessage.getValue().push("Something went wrong, Please try again later!"); this._apiService.errorMessage.next(this._apiService.errorMessage.getValue());
  //           } else return;

  //           this.spinner.hide('passwordSpinner');
  //         }
  //       });
  //   }
  // }

  // ValidateToken() {
  //   this.spinner.show('validateTokenSpinner');
  //   // if(this.countDown) this.countDown.unsubscribe();

  //   if (this.validateCodeForm.valid) {
  //     this._apiService
  //       .validateToken(this.validateCodeForm.value.code)
  //       .subscribe((response) => {
  //         if(response){
  //           let res:any = response;
  //           if (res.status == "ok") {
  //             this._apiService.errorOfValToken.next("");
  //             this.validateCodeForm.reset();
  //             this.msgValidated = "Token validated successfully!"
  //             setTimeout(() => {
  //               this.msgValidated = '';
  //               this.showTokenBar = false;
  //               this.counter = 300;
  //               this.countDown.unsubscribe();
  //               this.showValidationError = '';
  //               this._apiService.errorOfValToken.next("");
  //               this._apiService.disableButton.next(false);
  //               this.validateCodeForm.value.code = "";
  //               this.validateCodeForm.reset();
  //               this.showValidationError = '';
  //             }, 2500);
  //             setTimeout(() => {
  //               this.layoutService.rsToggleStatus.next(false);

  //             }, 4500);
  //           } else {
  //             this._apiService.errorOfValToken.next("Incorrect token");
              
  //             this._apiService.disableButton.next(true);
  //           }
  //         }
  //         this.spinner.hide('validateTokenSpinner');

  //       });
  //   }
  // }

  ngOnDestroy() {
    if(this.countDown) this.countDown.unsubscribe();
    this.subscriptions.forEach((subscription) => {
      subscription.unsubscribe();
    });
  }
}
